// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs-form-switch[data-v-b19d5c4c]:focus{box-shadow:none}.vs-form-switch[data-v-b19d5c4c]:focus,[type=checkbox][data-v-b19d5c4c]:checked:focus,[type=checkbox][data-v-b19d5c4c]:checked:hover{border:none;outline:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
